import * as Sentry from '@sentry/vue';
import Env from 'Services/Env';
import Store from 'Services/Store';

export default class ErrorsHandler {
    constructor() {
        this.config = Env.get('sentry');
        this.release = Env.get('release');
        this.env = Env.get('env');
    }

    /**
     * Initialize errors handler service.
     * Should be done as soon as possible to handle boot errors;
     */
    boot(app) {
        if (this.config) {
            Sentry.init({
                app,
                dsn: this.config.dsn,
                release: this.release,
                environment: this.env,
                integrations: [
                    Sentry.browserTracingIntegration(),
                    Sentry.vueIntegration({
                        tracingOptions: {
                            // we tried once to update his... RIP
                            trackComponents: true,
                        },
                    }),
                ],
                denyUrls: [/widget\.usetandem\.ai/],
                /**
                 * @see https://docs.sentry.io/platforms/javascript/#decluttering-sentry
                 */
                ignoreErrors: [
                    // Random plugins/extensions
                    'top.GLOBALS',

                    /**
                     * ResizeObserver loop errors are actually thrown by ElementUI
                     * More informations here {@see https://github.com/Fundebug/reproduce-ResizeObserver-loop-limit-exceeded}
                     */
                    'ResizeObserver loop limit exceeded',
                    'ResizeObserver loop completed with undelivered notifications',

                    // Axios HTTP Code 4xx errors
                    'Request failed with status code 4',

                    // @sellsy/sse network errors
                    /network ?error/i,
                    'Failed to fetch',
                    // Same issue as "Failed to fetch", but for Apple devices (MacOS, iOS) with Safari / Chrome
                    'Load failed',
                    'Échec de fetch',
                    'Impossible de se connecter au serveur',
                    'La requête a expiré',
                    'La connexion réseau a été perdue',
                    'Error in body stream',
                    /No activity within \d+ milliseconds\. Reconnecting/,

                    // UserAgent set in Firefox 74 & 75 (Library error)
                    'can\'t redefine non-configurable property "userAgent"',
                    'Request aborted',
                    'Fetch is aborted',
                    'Browser cached widget version unsupported.',
                ],
            });

            Sentry.setUser({ email: Store.get('user').email, id: Store.get('user').id });

            Sentry.setTag('tenantId', Store.get('corp').id);
            Sentry.setTag('Project', 'front');

            EventBus.on('on-new-request-id', (requestId) => {
                Sentry.setTag('requestId', requestId);
            });
        }
    }

    /**
     * @param {Error} e
     */
    logException(e) {
        if (!['localhost', 'review'].includes(this.env)) {
            Sentry.captureException(e);
        } else {
            console.error(e);
        }
    }
}
